import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-digital-edit-comment-dialog',
  templateUrl: './digital-edit-comment-dialog.component.html',
  styleUrls: ['./digital-edit-comment-dialog.component.scss']
})
export class DigitalEditCommentDialogComponent implements OnInit {
 
  constructor(public dialogRef:MatDialogRef<DigitalEditCommentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,) { }


    QuestionId=this.data.QuestionId;
    QuestionComment=this.data.comment_;
    
    

  ngOnInit() {
  }
  DialogClose(){
    this.dialogRef.close()
  }

  SaveQuestionComments(){
    
    this.dialogRef.close(this.QuestionComment)
  }
}
